import { ActiveFiltersBarSortStatusIcon } from "@/components/data-table/components/DataTableActiveFiltersBar/ActiveFiltersBarSortStatusIcon";
import { cn } from "@/lib/utils";
import { memo } from "react";

interface QueryTableFilteredSortedBadgeSortSegmentProps {
  sortDirection: "asc" | "desc" | null;
  segmentMutedClassName: string;
}

const QueryTableFilteredSortedBadgeSortSegmentComp = ({
  sortDirection,
  segmentMutedClassName,
}: QueryTableFilteredSortedBadgeSortSegmentProps) => (
  <span
    className={cn(
      "inline-flex shrink-0 items-center gap-1.5",
      segmentMutedClassName,
    )}
  >
    <ActiveFiltersBarSortStatusIcon
      sortDirection={sortDirection}
      className="size-3.5 shrink-0"
    />
    {sortDirection !== null ? <span className="tabular-nums">1</span> : null}
  </span>
);

export const QueryTableFilteredSortedBadgeSortSegment = memo(
  QueryTableFilteredSortedBadgeSortSegmentComp,
);
